/**
 * Step 4: Boundary Conditions — 嵌入灵活边界规则编辑器
 */
import React from 'react';
import { Alert } from 'antd';
import { useWizard } from './WizardContext';
import BoundaryConditionManager from '../BoundaryConditionManager';

interface Step4Props {
  data: any;
  onChange: (data: any) => void;
}

const Step4BoundaryConditions: React.FC<Step4Props> = () => {
  const { modelId } = useWizard();

  if (!modelId) {
    return (
      <Alert
        message="请先保存草稿"
        description="边界条件编辑需要模型ID。请先在「基本信息」页填写必要信息并点击「保存当前页」，获取模型ID后即可配置边界条件。"
        type="warning"
        showIcon
      />
    );
  }

  return <BoundaryConditionManager modelId={modelId} />;
};

export default Step4BoundaryConditions;
